import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

export default function QuestionPetsAtHomePage() {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    navigate('/onboarding/feedback-pet-safe-plants')
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.questionPetsAtHome.heading')}
      buttons={[
        {
          text: t('pages.onboarding.questionPetsAtHome.yesDogs'),
          value: 'yes_dogs',
        },
        {
          text: t('pages.onboarding.questionPetsAtHome.yesCats'),
          value: 'yes_cats',
        },
        {
          text: t('pages.onboarding.questionPetsAtHome.yesOther'),
          value: 'yes_other',
        },
        {
          text: t('pages.onboarding.questionPetsAtHome.noPets'),
          value: 'no_pets',
        },
      ]}
      onSubmit={handleSubmit}
    />
  )
}
